var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 1.66536H10V0.998698C10 0.632031 9.7 0.332031 9.33333 0.332031C8.96667 0.332031 8.66667 0.632031 8.66667 0.998698V1.66536H3.33333V0.998698C3.33333 0.632031 3.03333 0.332031 2.66667 0.332031C2.3 0.332031 2 0.632031 2 0.998698V1.66536H1.33333C0.593333 1.66536 0.00666673 2.26536 0.00666673 2.9987L0 12.332C0 13.0654 0.593333 13.6654 1.33333 13.6654H10.6667C11.4 13.6654 12 13.0654 12 12.332V2.9987C12 2.26536 11.4 1.66536 10.6667 1.66536ZM10.6667 11.6654C10.6667 12.032 10.3667 12.332 10 12.332H2C1.63333 12.332 1.33333 12.032 1.33333 11.6654V4.9987H10.6667V11.6654ZM5.33333 6.33203H3.33333C2.96667 6.33203 2.66667 6.63203 2.66667 6.9987V8.9987C2.66667 9.36537 2.96667 9.66537 3.33333 9.66537H5.33333C5.7 9.66537 6 9.36537 6 8.9987V6.9987C6 6.63203 5.7 6.33203 5.33333 6.33203Z",
    fill: "#D0D3D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCalendar);
export default __webpack_public_path__ + "static/media/small-calendar.ee2d67635646bd48e1add05f2ebead1f.svg";
export { ForwardRef as ReactComponent };